import { createContext } from 'react'

const LogOutContext = createContext(() => {})

export default LogOutContext
